import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from "../../../helpers/intlMessage";
import { Badge } from '@material-ui/core';
import Filtro from './Filtro/index';
import { useDispatch } from 'react-redux';
import * as commonActions from '../../../app/common/common.action';
import { httpRequest } from '@util/api-common.util';
import Grid from './Grid';
import { returnParamiters, returnStatus } from '../relatorio.utils';
import WebapiCommon from '@util/webapi.common';
import { BsFillPersonVcardFill } from 'react-icons/bs';
import { useIntl } from 'react-intl';

function Certificacao({
  onclickLine,
  showBtnImprimir,
}) {

  const lista = useSelector(state => state.solicitacao.listaSolicitacoes);
  const [filtro, setFiltro] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [listaLaudos, setListaLaudos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const offset = 20;
  const dispatch = useDispatch();
  const first = useRef();
  const firstfaturado = useRef();
  const intl = useIntl();

  useEffect(() => {
    if (first.current) {
      getData();
    }
    first.current = true;
  }, [pagina])

  function getData() {
    const { medico, periodoInicial, periodoFinal, tipo, value, certificado } = filtro;

    let params = returnParamiters({
      'medicoCertificador': medico,
      'dataInicio': periodoInicial,
      'dataFim': periodoFinal,
      'tipoFiltro': tipo,
      'tipoFiltroValue': value,
      "certificado": certificado,
      'pagina': pagina,
      'quantidadePaginacao': offset
    });

    if (tipo.indexOf('dt') >= 0) {
      const result = CommonFunctions.validaData(periodoInicial, periodoFinal, intl, commonActions);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }
    }

    if (medico) params.medicoCertificador = medico;
    dispatch(commonActions.showFadeCarregando(true));
    httpRequest('Relatorio/certificacao',
      'POST', {
      'medicoId': medico,
      'dataInicio': periodoInicial,
      'dataFim': periodoFinal,
      'tipoFiltro': tipo,
      'tipoFiltroValue': value,
      "certificado": certificado,
      'pagina': pagina,
      'quantidadePaginacao': offset
    }).then((response) => {
      if (response.totalItems === 0) {
        dispatch(
          commonActions.showAlerta(
            'alerta',
            <IntlMessage id="dashboards.reports.noResults" />,
            2000
          )
        );
      }
      setTotal(response && response.totalItems);
      setListaLaudos(response && response.data);
      dispatch(commonActions.showFadeCarregando(false));
    }).catch((error) => {
      console.error(error);
      dispatch(commonActions.showFadeCarregando(false));
    });
  }

  const filtrar = async filtro => {
    getData();
  };

  useEffect(() => {
    commonActions.mudarStatusModalFaturamento(false)
    const periodo = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = periodo;

    setFiltro({ periodoInicial, periodoFinal });
    loadItensFiltro();/*
    setTotal([{ label: <IntlMessage id="dashboards.reports.all" />, value: null }, ...lista]); */
  }, [lista]);

  const loadItensFiltro = async () => {
    try {
      const response = await WebapiCommon.getTiposExame();
      setTiposExame(response);
    } catch (error) { }
  };

  const formatItens = (l) => {
    if (l.length === 0) {
      commonActions.showAlerta(
        'error',
        <IntlMessage id="dashboards.examDetail.attachmentFailure" />,
        2000
      );
    } else {
      return l.map(item => {
        const { backgroundColor, color, label } = returnStatus(item);
        return {
          ...item,
          statusFormatted: (
            <Badge style={{ fontSize: '12px', backgroundColor, color }}>
              {label}
            </Badge>
          )
        };
      });
    }
  };

  return (
    <React.Fragment>
      <Filtro
        filtro={filtro}
        setFiltro={setFiltro}
        filtrar={filtrar}
        showBtnImprimir={showBtnImprimir}
      ></Filtro>
      {listaLaudos.length !== 0 && (
        <Grid
          setModalOpen={setModalOpen}
          lista={listaLaudos}
          totalItens={total}
          pagina={pagina}
          totalItensPage={20}
          setPagina={setPagina}
          onclickLine={onclickLine}
          commmonActions={commonActions}
        />
      )}
      {listaLaudos.length === 0 &&
        <div className='icone-semdados'>
          <BsFillPersonVcardFill width={'96px'} />
        </div>}
    </React.Fragment>
  );
}

export default Certificacao;


// WEBPACK FOOTER //
// ./src/pages/relatorio/Certificacao/index.js